import React from 'react'
import MuiTooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from 'styled-components'
import { Fade } from '@material-ui/core'

const DEFAULT_STYLE = {
  tooltip: {
    maxWidth: '210px',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    padding: '8px 16px'
  }
}

const StandardTooltipStyle = makeStyles(() => {
  const scTheme = useTheme()
  return {
    tooltip: {
      ...DEFAULT_STYLE.tooltip,
      fontFamily: scTheme.ds.typography.fontFamily,
      size: scTheme.ds.typography.size.small,
      color: scTheme.ds.colors.neutral600,
      backgroundColor: scTheme.ds.colors.info25,
      border: `1px solid ${scTheme.ds.colors.info200}`,
      textAlign: 'left',
      maxWidth: '300px'
    }
  }
})

const AlertTooltipStyle = makeStyles(() => {
  const scTheme = useTheme()
  return {
    tooltip: {
      ...DEFAULT_STYLE.tooltip,
      fontFamily: scTheme.ds.typography.fontFamily,
      color: scTheme.ds.colors.danger400,
      backgroundColor: scTheme.ds.colors.danger100,
      textAlign: 'left'
    },
    arrow: {
      color: scTheme.ds.colors.danger100
    }
  }
})

const NeutralTooltipStyle = makeStyles(() => {
  const scTheme = useTheme()
  return {
    tooltip: {
      ...DEFAULT_STYLE.tooltip,
      fontFamily: scTheme.ds.typography.fontFamily,
      color: scTheme.ds.colors.white,
      backgroundColor: '#616161E5',
      textAlign: 'left',
      fontSize: '10px',
      maxWidth: '120px'
    },
    arrow: {
      color: '#616161E5'
    }
  }
})

type Props = {
  children: React.ReactElement
  text: string
  className?: string
  type?: 'standard' | 'alert' | 'neutral'
}

export function TooltipNew({
  children,
  text,
  type = 'standard',
  className
}: Props) {
  const stylesByType = {
    standard: StandardTooltipStyle,
    alert: AlertTooltipStyle,
    neutral: NeutralTooltipStyle
  }
  const classes = stylesByType[type]()

  return (
    <MuiTooltip
      title={text}
      style={{ cursor: 'pointer' }}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 500 }}
      leaveDelay={200}
      enterDelay={100}
      className={className}
      classes={classes}
    >
      {children}
    </MuiTooltip>
  )
}
